/**
 * Formats a recording duration (in seconds) for the on-screen timer.
 *
 * Returns `mm:ss`, upgrading to `hh:mm:ss` once the duration reaches an hour. Non-finite or negative inputs are treated as 0 so the timer never renders garbage like "NaN:NaN".
 */
export function formatRecordingTime(seconds: number): string {
  const total = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;

  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;

  const mm = String(minutes).padStart(2, "0");
  const ss = String(secs).padStart(2, "0");

  return hours > 0 ? `${String(hours).padStart(2, "0")}:${mm}:${ss}` : `${mm}:${ss}`;
}
